import { render, staticRenderFns } from "./BlogElement.vue?vue&type=template&id=797edec6&"
import script from "./BlogElement.vue?vue&type=script&lang=js&"
export * from "./BlogElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports